<template>
  <Section
    title="Organizacja"
    description="Proszę podać organizację reprezentowaną w procesie weryfikacji"
  >
    <UserOrganizationList
      id="organization-list"
      :can-edit="false"
      :can-filter="false"
    />

    <Btn
      v-if="account.organizations.length < maxOrganizations"
      v-b-modal.add-organization
      variant="outline-primary"
      icon="user-plus"
    >
      Dodaj
      <span v-if="account.organizations.length > 0">kolejną</span> organizację
    </Btn>
    &nbsp;
    <PolmedSpinner v-if="loading"></PolmedSpinner>

    <b-modal
      id="add-organization"
      ref="add-organization"
      size="lg"
      hide-footer
      :title="isExisting ? 'Dołącz do organizacji' : 'Dodaj organizację'"
    >
      <OrganizationFormModal
        id="organization-edit"
        :can-select="true"
        :save-loaded="false"
        @form:sent="organizationAdded"
        @form:selected="organizationAdded"
        @organization:selected="organizationSelected"
      />
    </b-modal>
  </Section>
</template>

<script>
import UserOrganizationList from "./UserOrganizationList";
import OrganizationFormModal from "@/components/Organization/OrganizationFormModal";
import Section from "@/components/Elements/Section";

import { mapState, mapGetters } from "vuex";

export default {
  name: "UserOrganizations",
  components: {
    UserOrganizationList,
    OrganizationFormModal,
    Section
  },
  props: {
    maxOrganizations: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      isExisting: false
    };
  },
  computed: {
    ...mapState("Account", ["account", "loading"]),
    ...mapGetters("Account", { organizations: "getUserOrganizations" })
  },
  mounted() {
    if (this.organizations.length < 1) {
      this.$refs["add-organization"].show();
    }
  },
  methods: {
    organizationSelected(organization) {
      if (organization.id > 0) {
        this.isExisting = true;
      } else {
        this.isExisting = false;
      }
    },
    organizationAdded(organization) {
      this.$store
        .dispatch("Account/joinOrganization", {
          organizationId: organization.id,
          userId: this.account.id
        })
        .then(() => {
          this.$refs["add-organization"].hide();
          this.$emit("organization:added", organization);
        });
    }
  }
};
</script>
